var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as Headless from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
import { TouchTarget } from './button';
export function Toolbar(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({}, props, { className: clsx(className, 'flex flex-1 items-center gap-4 py-1') }));
}
export function ToolbarDivider(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({ "aria-hidden": "true" }, props, { className: clsx(className, 'h-5 w-px bg-zinc-950/10 dark:bg-white/10') }));
}
export function ToolbarSection(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({}, props, { className: clsx(className, 'flex items-center gap-3') }));
}
export function ToolbarSpacer(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({ "aria-hidden": "true" }, props, { className: clsx(className, '-ml-4 flex-1') }));
}
export const ToolbarButton = React.forwardRef(function ToolbarButton(_a, ref) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    let classes = clsx(
    // Base
    'relative flex min-w-0 items-center gap-3 rounded-md px-1.5 py-0.5 text-left text-sm/6 font-medium text-zinc-950 sm:text-xs/5', 
    // Hover
    'data-[hover]:bg-zinc-950/5', 
    // Active
    'data-[active]:bg-zinc-950/5 data-[slot=icon]:*:data-[active]:fill-zinc-950', 
    // Dark mode
    'dark:text-white', 'dark:data-[hover]:bg-white/5', 'dark:data-[active]:bg-white/5');
    return (_jsx("span", { className: clsx(className, 'relative'), children: _jsx(Headless.Button, Object.assign({}, props, { className: clsx(classes), ref: ref, children: _jsx(TouchTarget, { children: children }) })) }));
});
